import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import { Icon } from "../../ui";
import "./sales.css";

const AgreementPage = lazy(() => import("./agreements").then((m) => ({ default: m.AgreementPage })));
const AgreementsPage = lazy(() => import("./agreements").then((m) => ({ default: m.AgreementsPage })));
const CompaniesPage = lazy(() => import("./companies").then((m) => ({ default: m.CompaniesPage })));
const CompanyPage = lazy(() => import("./companies").then((m) => ({ default: m.CompanyPage })));
const LocationPage = lazy(() => import("./companies").then((m) => ({ default: m.LocationPage })));
const ContactPage = lazy(() => import("./contacts").then((m) => ({ default: m.ContactPage })));
const ContactsPage = lazy(() => import("./contacts").then((m) => ({ default: m.ContactsPage })));
const InboxPage = lazy(() => import("./inbox").then((m) => ({ default: m.InboxPage })));
const DealPage = lazy(() => import("./sales").then((m) => ({ default: m.DealPage })));
const SalesPage = lazy(() => import("./sales").then((m) => ({ default: m.SalesPage })));
const SalesSettings = lazy(() => import("./settings").then((m) => ({ default: m.SalesSettings })));

/** Sales: the board of deals, the Inbox, companies and their locations, contacts, and agreements. */

export const routes: SolutionRoute[] = [
  { solution: "sales", path: "sales", element: <SalesPage /> },
  { solution: "sales", path: "sales/deals/:id", element: <DealPage /> },
  { solution: "sales", path: "sales/inbox", element: <InboxPage /> },
  { solution: "sales", path: "sales/companies", element: <CompaniesPage /> },
  { solution: "sales", path: "sales/companies/:id", element: <CompanyPage /> },
  { solution: "sales", path: "sales/companies/:id/locations/:lid", element: <LocationPage /> },
  { solution: "sales", path: "sales/people", element: <ContactsPage /> },
  { solution: "sales", path: "sales/people/:id", element: <ContactPage /> },
  { solution: "sales", path: "sales/agreements", element: <AgreementsPage /> },
  { solution: "sales", path: "sales/agreements/:id", element: <AgreementPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "sales", key: "sales", label: "Sales", icon: Icon.briefcase, need: "sales.view", Component: SalesSettings }];
